var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BTooltip',{attrs:{"type":"is-white","size":"is-small","position":"is-bottom","multilined":true,"label":_vm.$t(_vm.label)}},[_c('IconHelp')],1)}
var staticRenderFns = []

export { render, staticRenderFns }